import React, { useContext, useEffect, useMemo } from "react";
import { CommonService } from "../../services/common/common.service";
import HeaderComponent from "../../components/header/header.component";
import { GlobalContext } from "../../store";

import { useTranslation } from "react-i18next";
import { ContentLayout } from "../../layouts/content/content.layout";
import SupportBlockComponent from "../../components/support/support.component";
import LessonDetailsContentComponent from "../../modules/educations/components/lesson-details/lesson-details-content/lesson-details-content.component";

const VideoDetailsPage = (props: any) => {
  const { t } = useTranslation();
  const lessonId = props.match.params.id;
  const commonService = useMemo(() => new CommonService(), []);
  const { setPageTitle } = useContext(GlobalContext);

  useEffect(() => {
    setPageTitle(t("PAGES_HEAD.EDUCATION_TITLE"));
  }, [t, setPageTitle, commonService]);

  return (
    <>
      <HeaderComponent />
      <ContentLayout>
        <LessonDetailsContentComponent lessonId={lessonId} />
        <SupportBlockComponent />
      </ContentLayout>
    </>
  );
};
export default VideoDetailsPage;
